export interface NavigationMenuItem {
  id?: number | string;
  label: string;
  icon?: string;
  link: string;
  childLink?: string;
  additionalActivationLinks?: string[];
  isLinkActive?: boolean;
  params?: string;
  hasAccess?: boolean;
  additionalClass?: string;
  dataTestId?: string;
}
